import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  view: 'login',
};

const authUiSlice = createSlice({
  name: 'authUi',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.open = true;
      state.view = action.payload.view;
      state.data = action.payload.data || null;
    },
    closeModal: (state) => {
      state.open = false;
      state.view = null;
      state.data = null;
    },
  },
});

export const { openModal, closeModal } = authUiSlice.actions;

export default authUiSlice.reducer;
